import { defineMessages } from 'react-intl-next';

export const archivePagesRestrictionWarningsI18n = defineMessages({
	inheritedRestrictionsPageOnlyTitle: {
		id: 'archive-pages.restrictions-warning.page-only.inherited-restrictions.title',
		defaultMessage: 'Access to the archived item will change',
		description:
			'Warning title for a content item when only its restrictions may be changed when it is archived because it inherited restrictions from an ancestor item in the content tree',
	},
	inheritedRestrictionsPageOnlyMessage: {
		id: 'archive-pages.restrictions-warning.page-only.inherited-restrictions.message',
		defaultMessage:
			'This item is restricted by a parent. After archiving, those restrictions won’t apply. <a>Learn more about inherited restrictions</a>',
		description:
			'Warning message for a content item when only its restrictions may be changed when it is archived because it inherited restrictions from an ancestor item in the content tree',
	},

	inheritedRestrictionsPageAndChildrenTitle: {
		id: 'archive-pages.restrictions-warning.page-and-children.inherited-restrictions.title',
		defaultMessage: 'Access to archived items will change',
		description:
			'Warning title for a content item when the restrictions for it and its children may be changed when it is archived because it inherited restrictions from an ancestor item in the content tree',
	},
	inheritedRestrictionsPageAndChildrenMessage: {
		id: 'archive-pages.restrictions-warning.page-and-children.inherited-restrictions.message',
		defaultMessage:
			'These items are restricted by a parent. After archiving, those restrictions won’t apply. <a>Learn more about inherited restrictions</a>',
		description:
			'Warning message for a content when the restrictions for it and its children may be changed when it is archived because it inherited restrictions from an ancestor item in the content tree',
	},

	ownRestrictionsChildrenTitle: {
		id: 'archive-pages.restrictions-warning.children-only.own-restrictions.title',
		defaultMessage: 'Access to remaining nested items will change',
		description:
			'Warning title about the restrictions for the children of a content item that is being archived because the children are inheriting restrictions from the content item',
	},
	ownRestrictionsChildrenMessage: {
		id: 'archive-pages.restrictions-warning.children-only.own-restrictions.message',
		defaultMessage:
			'These items are restricted by the parent you’re archiving. After archiving, their access will be based on their new position in the content tree. <a>Learn more about inherited restrictions</a>',
		description:
			'Warning message about the restrictions for the children of a content item that is being archived because the children are inheriting restrictions from the content item',
	},
});
